export default "/images/vendor/@coreui/icons/svg/flag/cif-mm.svg?42cba2ad129b3b63d95d37b783770aa6";